// extracted by mini-css-extract-plugin
export default {"container":"FX-z","title":"GX-z","link":"HX-z"};